module.exports = __webpack_public_path__ + "img/added-service-unit-07.5ee2b4a9.png";